import { ContainerPadding, CTA, Text, TokenTextAppearance, TokenTextColor } from '@volkswagen-onehub/components-core';
import React from 'react';
import { EXTERNAL_LINK } from '../../constants/form-constants';
import { isComerciales } from '../../helpers/carline-helpers';
import { Section } from '../screen/section';

interface Props {
	paddingTop?: ContainerPadding;
	paddingBottom?: ContainerPadding;
}

export function LegalesSection(props: Props) {
	const { paddingTop, paddingBottom } = props;

	const Legales = (
		<>
			<Text appearance={TokenTextAppearance.copy100} color={TokenTextColor.secondary}>
				Te informamos de que tus datos personales serán tratados por Volkswagen Group España Distribución S.A.U., en
				calidad de responsable del tratamiento, con la finalidad de atender tus consultas y solicitudes, realizar un
				control de calidad sobre los productos y servicios solicitados, realizar encuestas de opinión y estudios de
				mercado con fines estadísticos; y, en caso de que nos hayas dado tu consentimiento expreso, para las finalidades
				descritas en los consentimientos adicionales. Informarte que puedes ejercer los derechos que te confiere la
				normativa de protección de datos mediante solicitud escrita a{' '}
				<CTA tag="a" href={`mailto:${EXTERNAL_LINK.EMAIL_ATENCION_CLIENTE}`} target="_blank" emphasis="tertiary">
					{EXTERNAL_LINK.EMAIL_ATENCION_CLIENTE}
				</CTA>
				.
			</Text>
			<Text appearance={TokenTextAppearance.copy100} color={TokenTextColor.secondary}>
				Puedes consultar la información adicional sobre el tratamiento de tus datos en nuestra{' '}
				<CTA tag="a" href={EXTERNAL_LINK.POLITICA_PRIVACIDAD} target="_blank" emphasis="tertiary">
					política de privacidad
				</CTA>
				.
			</Text>
		</>
	);

	const LegalesComerciales = (
		<>
			<Text appearance={TokenTextAppearance.copy100} color={TokenTextColor.secondary}>
				Te informamos de que tus datos personales serán tratados por Volkswagen Group España Distribución S.A.U., en
				calidad de responsable del tratamiento, con la finalidad de poder cursar tu petición y, en caso de que nos hayas
				dado tu consentimiento expreso, para las finalidades descritas en los consentimientos adicionales. Informarte
				que puedes ejercer los derechos que te confiere la normativa de protección de datos mediante solicitud escrita a{' '}
				<CTA
					tag="a"
					href={`mailto:${EXTERNAL_LINK.EMAIL_ATENCION_CLIENTE_COMERCIALES}`}
					target="_blank"
					emphasis="tertiary"
				>
					{EXTERNAL_LINK.EMAIL_ATENCION_CLIENTE_COMERCIALES}
				</CTA>
				.
			</Text>
			<Text appearance={TokenTextAppearance.copy100} color={TokenTextColor.secondary}>
				Puedes consultar la información adicional sobre el tratamiento de tus datos en nuestra{' '}
				<CTA tag="a" href={EXTERNAL_LINK.POLITICA_PRIVACIDAD_COMERCIALES} target="_blank" emphasis="tertiary">
					política de privacidad
				</CTA>
				.
			</Text>
		</>
	);

	return (
		<Section paddingTop={paddingTop} paddingBottom={paddingBottom}>
			<Text appearance={TokenTextAppearance.copy100} color={TokenTextColor.secondary}>
				Texto legal de Volkswagen
			</Text>
			{isComerciales() ? LegalesComerciales : Legales}
		</Section>
	);
}
